import { formatShiftDateTime } from '@caresend/utils';
import { defineComponent, computed, onMounted, ref, watch } from 'vue';
import __vue_component__ from '../../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import { usePortalStore } from '../../store/portal/index.js';
import { unbindShiftAndDependencies, bindShiftAndDependencies } from '../../store/portal/set/index.js';
import __vue_component__$2 from '../../../ShiftItineraryCard/ShiftItineraryCard.vue.js';
import __vue_component__$4 from '../../../../symbols/X.vue.js';
import __vue_component__$1 from '../../../../transitions/TransitionFadeOutIn/TransitionFadeOutIn.vue.js';
import __vue_component__$3 from '../../../../ui/Skeleton.vue.js';
import 'immutability-helper';
import { getRoute, getRouter } from '../../../../../router/helpers/initRouter.js';
import '../../../../../router/routes/dev/model.js';
import '../../../../../router/routes/dev/routes.js';
import { DashboardRouteName } from '../../../../../router/routes/dashboard/model.js';
import '../../../../../router/routes/pro/model.js';
import '../../../../../router/routes/visitsPage/model.js';
import '@caresend/types';
import '../../../../../router/routes/orderFlow/model.js';
import '../../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../../router/routes/orderFlow/routes.js';
import '../../../../../router/routes/schedulingFlow/model.js';
import '../../../../../router/routes/schedulingFlow/routes.js';
import '../../../../../router/routes/chartingFlow/model.js';
import '../../../../../router/routes/chartingFlow/routes.js';
import '../../../../../router/routes/portal/portalRoutes.js';
import '../../../../../router/routes/portal/model.js';
import '../../../../../router/routes/visitsPage/routes.js';
import { getStore } from '../../../../../store/helpers/initStore.js';

var script = defineComponent({
    name: 'ShiftDetailsOverlay',
    components: {
        ButtonComponent: __vue_component__,
        TransitionFadeOutIn: __vue_component__$1,
        ShiftItineraryCard: __vue_component__$2,
        Skeleton: __vue_component__$3,
        X: __vue_component__$4,
    },
    setup() {
        const currentRoute = getRoute();
        const router = getRouter();
        const store = getStore();
        const portalStore = usePortalStore();
        const displayShiftID = computed(() => { var _a, _b; return (_b = (_a = currentRoute.value.query) === null || _a === void 0 ? void 0 : _a.shiftID) !== null && _b !== void 0 ? _b : null; });
        const variablesTasks = computed(() => { var _a; return (_a = store.state.variables.variables) === null || _a === void 0 ? void 0 : _a.tasks; });
        onMounted(async () => {
            if (displayShiftID.value) {
                await store.dispatch('shifts/bindShift', { id: displayShiftID.value });
            }
        });
        const shift = computed(() => {
            var _a;
            return !displayShiftID.value ? undefined
                : (_a = store.state.shifts.shifts) === null || _a === void 0 ? void 0 : _a[displayShiftID.value];
        });
        const shiftStartTime = computed(() => { var _a, _b, _c; return (_c = (_b = (_a = shift.value) === null || _a === void 0 ? void 0 : _a.startTime) === null || _b === void 0 ? void 0 : _b.timestamp) !== null && _c !== void 0 ? _c : Infinity; });
        const close = () => {
            const { query } = currentRoute.value;
            router.push({
                query: {
                    ...query,
                    shiftID: undefined,
                },
            });
        };
        const shiftDetailsRoute = computed(() => ({
            name: DashboardRouteName.SHIFT_DETAILS,
            params: {
                shiftID: displayShiftID.value,
            },
        }));
        const itineraries = computed(() => {
            var _a;
            return shift.value
                ? (_a = portalStore.shifts.get(shift.value.id)) === null || _a === void 0 ? void 0 : _a.computed.itineraries
                : undefined;
        });
        const loadingItineraries = ref(false);
        const formattedShiftDate = computed(() => shift.value ? formatShiftDateTime(shift.value) : undefined);
        watch(shift, async (newShift, oldShift) => {
            if (newShift === oldShift)
                return;
            if (oldShift) {
                unbindShiftAndDependencies();
            }
            if (!displayShiftID.value || !newShift) {
                return;
            }
            loadingItineraries.value = true;
            await bindShiftAndDependencies(newShift.id);
            loadingItineraries.value = false;
        }, { immediate: true });
        return {
            close,
            displayShiftID,
            formattedShiftDate,
            itineraries,
            loadingItineraries,
            shift,
            shiftDetailsRoute,
            shiftStartTime,
            variablesTasks,
        };
    },
});

export { script as default };
